"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const detect_utils_1 = require("@/common/detect_utils");
function default_1({ companyAddressForm, }) {
    const { formState: { errors }, register, } = companyAddressForm;
    const saveCompanyAddressOnEnter = (e) => {
        var _a;
        if (e.key === 'Enter') {
            (_a = document.getElementById('company_address_save')) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    const addressDetailErrorMsg = t('상세주소를 입력해주세요');
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "crdi_input_wrapper" }, { children: [(0, jsx_runtime_1.jsx)("input", Object.assign({}, register('company_address_detail', {
                required: addressDetailErrorMsg,
                validate: v => (0, detect_utils_1.validateWhiteSpace)(v) || addressDetailErrorMsg,
            }), { onKeyDown: saveCompanyAddressOnEnter, className: "crdi_input body2 gray-80", placeholder: t('상세주소'), maxLength: 250 })), errors.company_address_detail && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 error-main" }, { children: errors.company_address_detail.message })))] })));
}
exports.default = default_1;
